var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4851 17.1536L10.2231 10.8916C9.7231 11.3176 9.14811 11.6472 8.49811 11.8806C7.84811 12.1139 7.19477 12.2306 6.53811 12.2306C4.93677 12.2306 3.58144 11.6762 2.47211 10.5676C1.36277 9.45889 0.808105 8.10389 0.808105 6.50256C0.808105 4.90122 1.36211 3.54556 2.47011 2.43556C3.57811 1.32556 4.93277 0.76989 6.53411 0.768557C8.13544 0.767224 9.49144 1.32189 10.6021 2.43256C11.7128 3.54322 12.2681 4.89889 12.2681 6.49956C12.2681 7.19422 12.1451 7.86656 11.8991 8.51656C11.6531 9.16656 11.3298 9.72256 10.9291 10.1846L17.1911 16.4456L16.4851 17.1536ZM6.5391 11.2296C7.86577 11.2296 8.98577 10.7729 9.89911 9.85956C10.8124 8.94622 11.2691 7.82589 11.2691 6.49856C11.2691 5.17122 10.8124 4.05122 9.89911 3.13856C8.98577 2.22589 7.86577 1.76922 6.5391 1.76856C5.21244 1.76789 4.09211 2.22456 3.17811 3.13856C2.26411 4.05256 1.80744 5.17256 1.80811 6.49856C1.80877 7.82456 2.26544 8.94456 3.17811 9.85856C4.09077 10.7726 5.21077 11.2292 6.53811 11.2286M6.03811 8.88356V6.99956H4.15511V5.99956H6.04011V4.11556H7.04011V5.99956H8.9241V6.99956H7.04011V8.88456L6.03811 8.88356Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.30bb3717fa00163fab18e36bdcf375dc.svg";
export { ForwardRef as ReactComponent };